import { z } from "zod"

export const pdfLogo = z.object({
    id: z.string(),
    name: z.string(),
})

export const pdfLogoSettings = z.object({
    leftLogo: pdfLogo.optional(),
    rightLogo: pdfLogo.optional(),
})

export type PdfLogo = z.infer<typeof pdfLogo>
export type PdfLogoSettings = z.infer<typeof pdfLogoSettings>
